<template>
  <div class="page-header">
    <v-container style="padding: 0px;">
      <v-row justify="space-between" no-gutters>
        <v-col cols="5" no-gutters class="d-flex py-3 px-3">
          <!-- Button for Telephone -->
          <a
            href="tel:+441156786278"
            class="d-flex contact-link align-items-center mr-6"
          >
            <img
              class="logo mr-2"
              src="/static/icons/call-improve-microlearning-platform.png"
              style="height: 20px; width: 20px; padding: 0px;"
              alt="Call Improve"
            />
            <span class="header-contact-link">0115 6786278</span>
          </a>
          <!-- Button for Email -->
          <a
            id="email-link"
            href="mailto:hello@improve.online?subject=Customer%20Inquiry&body=Hello%20Improve%20Team,%0A%0AI%20would%20like%20to%20inquire%20about%20..."
            class="d-flex contact-link align-items-center"
          >
            <img
              class="logo mr-2"
              src="/static/icons/email-improve-microlearning-platform.png"
              style="height: 20px; width: 28px; padding: 0px;"
              alt="Email Improve"
            />
            <span class="header-contact-link">hello@improve.online</span>
          </a>
        </v-col>

        <v-col cols="7" no-gutters class="d-flex justify-end">
          <div id="top-header" class="py-3">
            <SearchInput :fontSize="14" />
            |
            <a
              text
              href="/about-us"
              class="mr-2 ml-2 fw-normal"
              style="font-size: 14px;"
              >About Us</a
            >|
            <a
              text
              href="/partner-programme"
              class="mr-2 ml-2 fw-normal"
              style="font-size: 14px;"
              >Partner Programme</a
            >|
            <a
              text
              href="/blog"
              class="mr-2 ml-2 fw-normal"
              style="font-size: 14px;"
              >Blog</a
            >
          </div>
          <a
            class="login-base-btn login-btn"
            :href="this.directUrl + '/#/login'"
            color="primary"
            >Login</a
          >
          <a
            class="login-base-btn partner-login-btn"
            :href="this.partnerUrl"
            color="success"
            >Partner Login</a
          >
        </v-col>
      </v-row>
    </v-container>
    <hr />
    <v-container style="padding: 0px 15px">
      <v-row>
        <v-col cols="3">
          <a href="/homepage" class="logo-anchor"
            ><img class="logo" src="/static/logo.png"
          /></a>
        </v-col>
        <v-col cols="9" class="text-right">
          <v-toolbar class="main-menu menu-desktop-view ">
            <v-toolbar-items
              class="justify-end d-flex align-items-center justify-end"
            >
              <v-btn class="main-menu-item" text to="/why-improve"
                >Why IMPROVE?</v-btn
              >
              <v-btn class="main-menu-item" text to="/features">Features</v-btn>
              <v-btn
                class="main-menu-item desktop-course-library"
                text
                to="/course-library"
                >Course Library
              </v-btn>
              <!-- <div
                class="desktop-course-library-hidden"
                style="position: relative;"
              >
                <div class="desktop-dropdown-menu">
                  <div class="desktop-dropdown-menu-item">
                    <a :href="this.directUrl +'/#/courses/cyber-security'">Cyber Security</a>
                  </div>
                </div>
              </div> -->
              <v-btn class="main-menu-item" text to="/pricing">Pricing</v-btn>
              <!-- <v-btn
                class="main-menu-item"
                text
                to="/case-studies"
                :class="currentRouteName == 'case-studies' ? 'active' : ''"
                >Case Studies</v-btn
              > -->
              <v-btn class="main-menu-item" text to="/contact"
                >Request a Demo</v-btn
              >
              <a
                :href="this.directUrl+'/#/signup?ref=website'"
                class="request-demo-btn ml-3 d-flex align-self-center"
                >Free Trial</a
              >
            </v-toolbar-items>
          </v-toolbar>
          <header class="header menu-tablet-view ">
            <input class="menu-btn" type="checkbox" id="menu-btn" />
            <label class="menu-icon" for="menu-btn"
              ><span class="navicon"></span
            ></label>
            <ul class="menu">
              <li>
                <SearchInput :fontSize="16" />
              </li>
              <li>
                <a href="/why-improve"><span>Why IMPROVE?</span></a>
              </li>
              <li>
                <a href="/features"><span>Features</span></a>
              </li>
              <li>
                <a href="/partner-programme">
                  <span>Partner Programme</span>
                </a>
              </li>
              <li class="tablet-course-library">
                <a href="/course-library"><span>Course Library</span></a>
                <!-- <div class="tablet-course-library-hidden">
                  <div class="tablet-dropdown-menu-item">
                    <a href="/courses/cyber-security">Cyber Security</a>
                  </div>
                </div> -->
              </li>
              <li>
                <a href="/pricing"><span>Pricing</span></a>
              </li>
              <!-- <li>
                <a href="/pricing"><span>Case Studies</span></a>
              </li> -->
              <li>
                <a href="/contact"><span>Request a Demo</span></a>
              </li>
              <li>
                <a v-bind:href="getReferralID"><span>Free Trial</span></a>
              </li>
            </ul>
          </header>
          <header class="header menu-mobile-view">
            <input class="menu-btn2" type="checkbox" id="menu-btn2" />
            <label class="menu-icon" for="menu-btn2"
              ><span class="navicon"></span
            ></label>
            <ul class="menu">
              <li>
                <SearchInput :fontSize="16" />
              </li>
              <li>
                <a href="/why-improve"><span>Why IMPROVE?</span></a>
              </li>
              <li>
                <a href="/features"><span>Features</span></a>
              </li>
              <li>
                <a href="/partner-programme">
                  <span>Partner Programme</span>
                </a>
              </li>
              <li class="mobile-course-library">
                <a href="/course-library"><span>Course Library</span></a>
                <!-- <div class="mobile-course-library-hidden">
                  <div class="mobile-dropdown-menu-item">
                    <a href="/courses/cyber-security">Cyber Security</a>
                  </div>
                </div> -->
              </li>
              <li>
                <a href="/pricing"><span>Pricing</span></a>
              </li>
              <!-- <li>
                <a href="/pricing"><span>Case Studies</span></a>
              </li> -->
              <li>
                <a href="/contact"><span>Request a Demo</span></a>
              </li>
              <li>
                <a v-bind:href="getReferralID"><span>Free Trial</span></a>
              </li>
            </ul>
          </header>
        </v-col>
      </v-row>
    </v-container>

    <div class="benefits-bar">
      <v-container style="padding:0px 15px;">
        <div class="d-flex">
          <v-col class="benefit-item">
            <img
              class="logo mr-2"
              src="/static/icons/benefits/improve-people-development-solution.png"
              style="height: 15px; width: 20px; padding: 0px;"
              alt="People Development"
            />
            <span>24/7 ACCESS TO COURSES</span>
          </v-col>
          <v-col class="benefit-item">
            <img
              class="logo mr-2"
              src="/static/icons/benefits/integration-support-icon.png"
              style="height: 18px; width: 18px; padding: 0px;"
              alt="Integration Support"
            />
            <span>HR APP INTEGRATIONS</span></v-col
          >
          <v-col class="benefit-item">
            <img
              class="logo mr-2"
              src="/static/icons/benefits/induction-training-software-for-businesses.png"
              style="height: 18px; width: 18px; padding: 0px;"
              alt="Induction training"
            />
            <span>14 DAY FREE TRIAL</span></v-col
          >
          <v-col class="benefit-item">
            <img
              class="logo mr-2"
              src="/static/icons/benefits/improves-microlearning-courses.png"
              style="height: 15px; width: 15px; padding: 0px;"
              alt="120+ Microlearning Courses"
            />
            <span>120+ MICROLEARNING COURSES</span></v-col
          >
          <v-col id="mc-benefit" class="benefit-item">
            <img
              class="logo mr-2"
              src="/static/icons/benefits/compliance-management-for-businesses.png"
              style="height: 17px;width: 12px; padding: 0px;"
              alt="Complance Management"
            />
            <span>COMPLIANCE MANAGEMENT</span></v-col
          >
        </div>
      </v-container>
    </div>
  </div>
</template>

<style>
.page-header {
  font-family: 'Sora', sans-serif;
}

.header-contact-link {
  font-size: 15px;
  font-weight: bold;
}

hr {
  margin: 0;
  border: 0;
  border-bottom: 1px solid #66666657;
}

.login-base-btn {
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 140px;
  margin-left: 10px;
}

.flex-sm-column-custom,
.request-demo-btn {
  white-space: nowrap;
  overflow: hidden;
}
div#top-header {
  white-space: nowrap;
}

.login-btn {
  background-color: #6bc091;
  color: #122034 !important;
}

.partner-login-btn {
  background-color: #122034;
  color: #ffffff !important;
  margin: 0 10px 0 10px;
  margin-right: 15px;
}

.logo {
  padding: 0 !important;
}

.benefits-bar {
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.benefit-item {
  background-color: #f5f5f5;
  padding: 10px 0px !important;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  max-width: 20%;
}
.benefit-item:first-child {
  justify-content: flex-start;
}

.benefit-item:last-child {
  justify-content: flex-end;
}

.benefit-item span {
  margin-left: 5px;
  font-size: 10px;
  font-weight: bold;
  color: #676767;
  letter-spacing: 0.15em;
}

/* Tablet View */
@media (min-width: 600px) and (max-width: 959px) {
  #mc-benefit,
  #lms-benefit,
  #top-header,
  #email-link {
    display: none !important;
  }

  .benefit-item {
    max-width: 33.33%;
    justify-content: center;
  }

  .benefit-item:nth-child(3) {
    justify-content: center;
  }

  .benefit-item span {
    font-size: 9px;
  }

  .logo {
    height: 56px;
    width: auto !important;
  }
}

@media (max-width: 599px) {
  #mc-benefit,
  #lms-benefit,
  #top-header,
  #email-link,
  .benefits-bar {
    display: none !important;
  }

  .page-header {
    border-bottom: 1px solid #66666657;
  }

  .logo {
    height: 44px;
    width: auto !important;
  }

  .login-base-btn,
  .header-contact-link {
    font-size: 12px;
  }
}
</style>

<script>
import { IMPROVE_CONFIG } from '@/config.js';
import SearchInput from "@/components/SearchInput.vue";

export default {
  data() {
    return {
      directUrl: IMPROVE_CONFIG.DIRECT_URL,
      partnerUrl: IMPROVE_CONFIG.PARTNER_URL,
    }
  },
  components: {
    SearchInput,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    getReferralID: function() {
      if (
        localStorage.getItem('refID') != null ||
        localStorage.getItem('refID') != undefined
      ) {
        return (
          this.directUrl + '/#/signup?ref=website&afi=' +
          localStorage.getItem('refID')
        );
      } else {
        return this.directUrl + '/#/signup?ref=website';
      }
    },
  },
};
</script>
